import React from "react";
import data from "../../data/blog/forthwroth.json";

function lastContent() {
  const Data = data[4]; // Access ParkingOptions directly

  return (
    <div className="mx-auto max-w-5xl px-4 text-lg text-[#2b3252]">
      {Data.mainData.map((item, index) => {
        return (
          <div key={index} className="">
            <h2 id={item.id} className="blogtitle">{item.title}</h2>
            <p
  className="blogcontent"
  dangerouslySetInnerHTML={{ __html: item.description }}
></p>

            {item.descr2 && <p className="blogcontent">{item.descr2}</p>}

            {item.section.map((section, sectionIndex) => {
              return (
                <div key={sectionIndex} className="mb-6">
                  <h3 id={section.id} className="blogSubtitle">
                    {section.title}
                  </h3>
                  <p
  className="blogcontent"
  dangerouslySetInnerHTML={{ __html: section.des }}
></p>
{section.des1 && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: section.des1 }}
  ></p>
)}
{section.des2 && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: section.des2 }}
  ></p>
)}

                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default lastContent;
